/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { VehicleIconLinkVehicleFragmentDoc } from '../VehicleIconLink/vehicleIconLink.hook'
import {
  AlertHistoryAdAlertFragmentDoc,
  AlertHistoryTaskFragmentDoc,
} from './AlertHistory/AlertHistory.hook'
import { KeepVehicleCenteredOnMapButtonVehicleFragmentDoc } from './KeepVehicleCenteredOnMapButton/KeepVehicleCenteredOnMapButton.hook'
export type BaseAlertCardTask_HubServiceNotification_Fragment = {
  __typename: 'HubServiceNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_IvcTaskNotification_Fragment = {
  __typename: 'IvcTaskNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_PassengerAuthentificationFallbackRequestedNotification_Fragment =
  {
    __typename: 'PassengerAuthentificationFallbackRequestedNotification'
    id: string
    status: Types.TaskNotificationStatus
    notificationType: Types.TaskNotificationType
    assigned: {
      __typename?: 'TaskStateChangeDetails'
      backofficeUser: {
        __typename?: 'BackofficeUser'
        id: string
        username: string
      } | null
    } | null
    stateChanges: Array<{
      __typename: 'TaskStateChangeDetails'
      initiatedBySystem: boolean
      timestamp: string | null
      to: Types.TaskNotificationStatus
      backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
    }>
  }

export type BaseAlertCardTask_PassengerUnbuckled_Fragment = {
  __typename: 'PassengerUnbuckled'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_RoadBlockageTaskNotification_Fragment = {
  __typename: 'RoadBlockageTaskNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_ShiftDeviationNotification_Fragment = {
  __typename: 'ShiftDeviationNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_StopAccessibilityDownvotedByDrivers_Fragment = {
  __typename: 'StopAccessibilityDownvotedByDrivers'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_StopActivationFailedNotification_Fragment = {
  __typename: 'StopActivationFailedNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_StopAreaMissingActiveStopsNotification_Fragment =
  {
    __typename: 'StopAreaMissingActiveStopsNotification'
    id: string
    status: Types.TaskNotificationStatus
    notificationType: Types.TaskNotificationType
    assigned: {
      __typename?: 'TaskStateChangeDetails'
      backofficeUser: {
        __typename?: 'BackofficeUser'
        id: string
        username: string
      } | null
    } | null
    stateChanges: Array<{
      __typename: 'TaskStateChangeDetails'
      initiatedBySystem: boolean
      timestamp: string | null
      to: Types.TaskNotificationStatus
      backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
    }>
  }

export type BaseAlertCardTask_StopDownVotedByDrivers_Fragment = {
  __typename: 'StopDownVotedByDrivers'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_StopPotentiallyUnreachable_Fragment = {
  __typename: 'StopPotentiallyUnreachable'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_StopValidationFailed_Fragment = {
  __typename: 'StopValidationFailed'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_TimeManagementNotification_Fragment = {
  __typename: 'TimeManagementNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_TripPrebookingNoAssignment_Fragment = {
  __typename: 'TripPrebookingNoAssignment'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_VehicleAvailabilityNotification_Fragment = {
  __typename: 'VehicleAvailabilityNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_VehicleIncidentNotification_Fragment = {
  __typename: 'VehicleIncidentNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_VehicleSurveillanceNotification_Fragment = {
  __typename: 'VehicleSurveillanceNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTask_VehicleWaypointAttendance_Fragment = {
  __typename: 'VehicleWaypointAttendance'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardTaskFragment =
  | BaseAlertCardTask_HubServiceNotification_Fragment
  | BaseAlertCardTask_IvcTaskNotification_Fragment
  | BaseAlertCardTask_PassengerAuthentificationFallbackRequestedNotification_Fragment
  | BaseAlertCardTask_PassengerUnbuckled_Fragment
  | BaseAlertCardTask_RoadBlockageTaskNotification_Fragment
  | BaseAlertCardTask_ShiftDeviationNotification_Fragment
  | BaseAlertCardTask_StopAccessibilityDownvotedByDrivers_Fragment
  | BaseAlertCardTask_StopActivationFailedNotification_Fragment
  | BaseAlertCardTask_StopAreaMissingActiveStopsNotification_Fragment
  | BaseAlertCardTask_StopDownVotedByDrivers_Fragment
  | BaseAlertCardTask_StopPotentiallyUnreachable_Fragment
  | BaseAlertCardTask_StopValidationFailed_Fragment
  | BaseAlertCardTask_TimeManagementNotification_Fragment
  | BaseAlertCardTask_TripPrebookingNoAssignment_Fragment
  | BaseAlertCardTask_VehicleAvailabilityNotification_Fragment
  | BaseAlertCardTask_VehicleIncidentNotification_Fragment
  | BaseAlertCardTask_VehicleSurveillanceNotification_Fragment
  | BaseAlertCardTask_VehicleWaypointAttendance_Fragment

export type BaseAlertCardAdAlertFragment = {
  __typename: 'FccAdAlert'
  id: string
  status: Types.FccAdAlertStatus
  type: Types.FccAdAlertType
  assignee: {
    __typename?: 'BackofficeUser'
    id: string
    username: string
  } | null
  statusChanges: Array<{
    __typename: 'FccAdAlertStatusChange'
    bySystem: boolean
    date: string
    to: Types.FccAdAlertStatus
    byUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type BaseAlertCardVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  isSelfDriving: boolean
  inService: boolean | null
  label: number | null
}

export const BaseAlertCardTaskFragmentDoc = gql`
    fragment BaseAlertCardTask on TaskNotification {
  __typename
  id
  status
  notificationType
  assigned {
    backofficeUser {
      id
      username
    }
  }
  stateChanges {
    __typename
  }
  ...AlertHistoryTask
}
    ${AlertHistoryTaskFragmentDoc}`
export const BaseAlertCardAdAlertFragmentDoc = gql`
    fragment BaseAlertCardAdAlert on FccAdAlert {
  __typename
  id
  status
  type
  assignee {
    id
    username
  }
  statusChanges {
    __typename
  }
  ...AlertHistoryAdAlert
}
    ${AlertHistoryAdAlertFragmentDoc}`
export const BaseAlertCardVehicleFragmentDoc = gql`
    fragment BaseAlertCardVehicle on Vehicle {
  id
  ...KeepVehicleCenteredOnMapButtonVehicle
  ...VehicleIconLinkVehicle
}
    ${KeepVehicleCenteredOnMapButtonVehicleFragmentDoc}
${VehicleIconLinkVehicleFragmentDoc}`
